import React from 'react';
import useScaler from '../hooks/Scaler';
import { makeStyles } from '@material-ui/styles';

const blockerWidth = 32;
const blockerOffset = -blockerWidth / 2;

const useStyles = makeStyles(theme => ({
  embedResponsive: theme.embedResponsive,
  root: {
    display: 'flex',
    height: ({ viewHeight }) => `${viewHeight}px`,
    margin: ({ vMargin, hMargin }) => `${vMargin}px ${hMargin}px`
  },
  scene: {
    position: 'absolute',
    width: ({ width }) => width,
    height: ({ height }) => height,
    transform: ({ transform }) => transform,
    transformOrigin: ({ transformOrigin }) => transformOrigin
  },
  leftBlocker: {
    position: 'absolute',
    top: '0px',
    left: `${blockerOffset}px`,
    width: `${blockerWidth}px`,
    height: '100%'
  },
  rightBlocker: {
    position: 'absolute',
    top: '0px',
    right: `${blockerOffset}px`,
    width: `${blockerWidth}px`,
    height: '100%'
  },
  topBlocker: {
    position: 'absolute',
    top: `${blockerOffset}px`,
    width: '100%',
    height: `${blockerWidth}px`
  },
  bottomBlocker: {
    position: 'absolute',
    bottom: `${blockerOffset}px`,
    width: '100%',
    height: `${blockerWidth}px`
  }
}));

const Scene = ({ name, frame, swapZoom, children }) => {
  const {
    width,
    height,
    viewHeight,
    vMargin,
    hMargin,
    transform,
    transformOrigin
  } = useScaler();
  const {
    embedResponsive,
    root,
    scene,
    leftBlocker,
    rightBlocker,
    topBlocker,
    bottomBlocker
  } = useStyles({
    width,
    height,
    viewHeight,
    vMargin,
    hMargin,
    transform,
    transformOrigin,
    swapZoom
  });
  const bucketUrl =
    process.env.REACT_APP_ENV === 'production'
      ? 'https://www.pttepworld.space'
      : process.env.REACT_APP_ENV === 'development'
      ? 'https://dev.pttepworld.space'
      : '';
  return (
    <div className={root}>
      <div className={embedResponsive}>
        <iframe
          src={`/scenes/index.html?bucket_url=${bucketUrl}&name=${name}&verbose=${
            process.env.REACT_APP_ENV === 'production' ? 'false' : 'true'
          }`}
          title="content"
          ref={frame}
          scrolling="no"
          className={scene}
          frameBorder="0"
          allowFullScreen
          onLoad={() => {
            console.log('finished loading');
          }}
        />
        {// only iOS needs these blockers
        navigator.userAgent.match(/(iPad|iPhone|iPod)/g) && (
          <>
            <div className={leftBlocker} onClick={e => e.stopPropagation()} />
            <div className={rightBlocker} onClick={e => e.stopPropagation()} />
            <div className={topBlocker} onClick={e => e.stopPropagation()} />
            <div className={bottomBlocker} onClick={e => e.stopPropagation()} />
          </>
        )}
        {children}
      </div>
    </div>
  );
};

export default Scene;
